export const PRACTICE_PREFIX = "practice"
